import { useEffect, useState } from 'react';

/** Delays reflecting `value` until it has stopped changing for `delayMs` -- used to debounce search inputs so every keystroke doesn't fire its own request (Part 21 "debounced search"). */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
